/* =============================================================================
   SmoothScroll — Lenis-powered inertial scrolling
   =============================================================================
   Wraps the app and drives Lenis on every animation frame. This is the single
   biggest "premium feel" lever: it replaces the browser's stepped scroll with a
   smooth, weighted glide. Respects prefers-reduced-motion by not initialising.
   ============================================================================= */

import { useEffect } from "react";
import Lenis from "lenis";

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const SmoothScroll = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    if (prefersReducedMotion()) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let frame = 0;
    const raf = (time: number) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return <>{children}</>;
};

export default SmoothScroll;
